import { createReducer } from '../../../../../utils/ReduxUtils';
import * as types from '../../../actionTypes';

/** @typedef {Record<string, boolean>} UserUiSelectLoadingReducer */
/** @type {UserUiSelectLoadingReducer} */
const initialState = {};

const isLoading = (state, { meta }) => {
  const { selectId } = meta;
  if (selectId) {
    return { ...state, [selectId]: true };
  }
  return state;
};

const isEnding = (state, { meta }) => {
  const { selectId } = meta;
  if (selectId) {
    return { ...state, [selectId]: false };
  }
  return state;
};

export default createReducer(initialState, {
  [types.FETCH_USERS_REQUEST]: isLoading,
  [types.FETCH_USERS_SUCCESS]: isEnding,
  [types.FETCH_USERS_FAILURE]: isEnding,
});
